import { ddLogger } from './instances/dataDogLogger';
import { serverLogger } from './instances/serverLogger';

const isDevelopment = process.env.NODE_ENV !== 'development';
const isServerSide = typeof window === 'undefined';

export const logger = isServerSide ? serverLogger : isDevelopment ? console : ddLogger();
